import {gql} from "@apollo/client";

export const UPDATE_REVENUE_SETTINGS = gql`
  mutation updateRevenueSettings($settings: TenantRevenueParams!) {
    updateRevenueSettings(settings: $settings)
  }
`;
